import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { StateService } from "./services/state.service";
import { TitleService } from "./services/title.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [MessageService],
})
export class AppComponent implements OnInit {
  title = "catMan-ui";
  result: any;
  toastMarginClass: "right-toolbar-open" | "right-toolbar-close" =
    "right-toolbar-open";

  constructor(
    public stateService: StateService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    public messageService: MessageService,
    public translate: TranslateService,
    private readonly titleService: TitleService,
  ) {
    //translation

    translate.addLangs(["en", "pt", "es"]);
    translate.setDefaultLang("en");

    const mac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    if (!mac) {
      window.document.body.id = "custom-scrollbar";
    }

    this.route.queryParams.subscribe((params: any) => {
      if (params.access_token && params.refresh_token) {
        window.localStorage.c = params.access_token;
        window.localStorage.d = params.refresh_token;
        window.localStorage.i = params.id;
        // This is the first time here we set the tokenExpiryDate
        this.stateService.setTokenExpiryDate();

        const redirectURL =
          sessionStorage.getItem("callbackURL") || this.router.url;

        if (redirectURL) {
          const urlTree = this.router.parseUrl(redirectURL);

          // Extract the path safely
          const path =
            urlTree.root.children["primary"]?.segments
              .map((segment) => segment.path)
              .join("/") || "";

          // Extract query parameters safely
          const queryParams = Object.keys(urlTree.queryParams).length
            ? urlTree.queryParams
            : null;

          // Navigate with or without query params
          this.router.navigate([path], {
            ...(queryParams ? { queryParams } : {}), // Add query params only if they exist
            replaceUrl: true,
          });
        }
      }
    });
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.titleService.setDefaultTitle();
        this.titleService.setFavicon();
      }
    });
    this.openToast();
    this.openSoftWarningToast();
  }

  closeDownloadToast() {
    this.stateService.isDownload = false;
    this.messageService.clear("downloadToast");
  }
  openToast() {
    this.stateService.Result.subscribe((data: any) => {
      this.messageService.add({
        key: "downloadToast",
        severity: "info",
        summary: "Warn Message",
        sticky: true,
        closable: false,
      });
    });
  }
  openSoftWarningToast() {
    this.stateService.openSoftWarningToast.subscribe((data: any) => {
      if (data) {
        this.toastMarginClass = data["marginClass"];
        this.messageService.add({
          key: "softWarningToast",
          severity: "info",
          summary: "Warn Message",
          detail: data["message"],
          life: 5000,
          closable: false,
        });
      }
    });
  }
  closeSoftWarningToast() {
    this.messageService.clear("softWarningToast");
  }
}
